import giftTotebag from "../../../assets/gift-totebag-final.webp";

export default function OpenGift() {
  return (
    <section id="gift" className="relative py-20 md:py-24 bg-background-100">
      <div className="rope-border absolute top-0 left-0 right-0 opacity-90" />

      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-3 mb-3">
            <span className="h-px w-8 bg-primary-500" />
            <span className="font-label tracking-widest text-primary-600 text-sm">
              PRESENT
            </span>
            <span className="h-px w-8 bg-primary-500" />
          </div>
          <h2 className="font-heading font-black text-3xl md:text-4xl text-foreground-950">
            ご注文<span className="text-primary-600">＆フォロー</span>でプレゼント！
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Left: tote bag — final design */}
          <div className="relative order-2 lg:order-1">
            <div className="absolute -top-5 -left-3 z-10 bg-primary-600 text-background-50 dark:text-foreground-950 rounded-full px-5 py-2 font-heading font-black text-sm md:text-base whitespace-nowrap rotate-[-4deg] shadow-lg">
              フォロー特典
            </div>
            <div className="rounded-2xl border border-background-200 bg-background-50 shadow-lg aspect-[4/5] max-w-[380px] mx-auto overflow-hidden flex items-center justify-center p-6">
              <img
                src={giftTotebag}
                alt="オリジナルコットントートバッグ"
                loading="lazy"
                className="w-full h-full object-contain"
              />
            </div>
            <p className="text-center text-xs md:text-sm text-foreground-600 mt-3">
              オリジナルコットントートバッグ
            </p>
          </div>

          {/* Right: copy */}
          <div className="order-1 lg:order-2">
            <div className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200">
              <p className="font-heading font-black text-primary-600 text-xl md:text-2xl mb-3 leading-snug">
                ご来店ありがとうございます！
              </p>
              <p className="text-sm md:text-base text-foreground-800 leading-relaxed">
                ブランド名をレイアウトし、港町をイメージした錨とロープのモチーフをあしらった、シンプルで日常使いしやすいデザインです。
                <br />
                お買い物やお出かけはもちろん、毎日気軽にお使いいただけるバッグに仕上がりました。
              </p>
              <p className="mt-4 text-sm md:text-base text-foreground-800 leading-relaxed">
                カレーをご注文＆当店の公式
                <a
                  href="https://www.instagram.com/kobe.minatomachicurry"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary-600 font-bold underline underline-offset-2"
                >
                  Instagram
                </a>
                をフォローしていただくと、このオリジナルコットントートバッグをプレゼントいたします。
              </p>
              <p className="mt-4 text-sm md:text-base text-primary-700 font-heading font-bold leading-relaxed">
                ぜひ、「KOBE ミナトマチカレー」とともにお楽しみください。
              </p>

              {/* キャンペーン詳細 */}
              <dl className="mt-5 text-xs md:text-sm text-foreground-700 divide-y divide-background-200 border-t border-b border-background-200">
                <div className="flex gap-3 py-2">
                  <dt className="w-20 shrink-0 font-bold text-foreground-800">期間</dt>
                  <dd>期間の定めなし（なくなり次第終了）</dd>
                </div>
                <div className="flex gap-3 py-2">
                  <dt className="w-20 shrink-0 font-bold text-foreground-800">条件</dt>
                  <dd>カレーのご注文＋公式Instagramのフォロー</dd>
                </div>
                <div className="flex gap-3 py-2">
                  <dt className="w-20 shrink-0 font-bold text-foreground-800">プレゼント</dt>
                  <dd>オリジナルコットントートバッグ（お一人様1点限り）</dd>
                </div>
                <div className="flex gap-3 py-2">
                  <dt className="w-20 shrink-0 font-bold text-foreground-800">数量</dt>
                  <dd>限定100枚・なくなり次第終了</dd>
                </div>
                <div className="flex gap-3 py-2">
                  <dt className="w-20 shrink-0 font-bold text-foreground-800">お問い合わせ</dt>
                  <dd>
                    株式会社なちゅらフーズ
                    <br />
                    <a href="tel:0667324128" className="text-primary-700 font-bold cursor-pointer">
                      06-6732-4128
                    </a>
                    （平日9:00〜16:00）
                  </dd>
                </div>
              </dl>
              <p className="mt-3 text-[11px] md:text-xs text-foreground-500 leading-relaxed">
                ※画像はイメージです。※内容は予告なく変更・終了となる場合がございます。
              </p>

              <div className="mt-6 flex flex-wrap gap-3">
                <a
                  href="https://www.instagram.com/kobe.minatomachicurry"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 h-11 min-h-[44px] px-6 rounded-full bg-primary-600 hover:bg-primary-700 text-background-50 dark:text-foreground-950 font-heading font-bold text-sm whitespace-nowrap cursor-pointer transition"
                >
                  <i className="ri-instagram-line"></i>
                  Instagramをフォロー
                </a>
                <a
                  href="#store"
                  className="inline-flex items-center gap-2 h-11 min-h-[44px] px-6 rounded-full bg-background-50 border-2 border-primary-600 text-primary-600 hover:bg-primary-50 font-heading font-bold text-sm whitespace-nowrap cursor-pointer transition"
                >
                  <i className="ri-map-pin-2-line"></i>
                  店舗情報を見る
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="rope-border absolute bottom-0 left-0 right-0 opacity-90" />
    </section>
  );
}
